










import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class LinkArea extends Vue {
  private buttonList = [
    {
      name: 'BranchStudentList',
      text: '生徒一覧',
    },
    {
      name: 'BranchStudyList',
      text: 'テスト一覧',
    },
  ]

  private onClickButton(routerName: string) {
    if (this.$router.currentRoute.name !== routerName) this.$router.push({ name: routerName })
  }

  private colortype(name: string): string {
    if (this.$router.currentRoute.name === name) return 'link-active'
    else return 'link'
  }
}
